import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default abstract class EditableGridHandler<TPresenter extends WidgetsPresenter = WidgetsPresenter> {
  protected readonly _presenter: TPresenter;
  private readonly _gridId: string;
  focusHandler: (() => void) | null = null;

  protected constructor(gridId: string, presenter: TPresenter) {
    this._presenter = presenter;
    this._gridId = gridId;
  }

  get gridId(): string {
    return this._gridId;
  }

  get presenter(): TPresenter {
    return this._presenter;
  }

  get metadata() {
    return this.presenter.fetchMetadata();
  }

  get object() {
    return this.presenter.fetchRecord();
  }

  get dispatcher() {
    return this.presenter.fetchDispatcher();
  }

  get entityType() {
    return this.presenter.entityType;
  }

  listVisibleColumns(): EditScreenGridColumn[] {
    return [{} as EditScreenGridColumn];
  }

  listCurrentlyVisibleColumns(): EditScreenGridColumn[] {
    return this.listVisibleColumns();
  }
}
